import {WidgetsPresenter} from "@/utils/presenters/interfaces.ts";
import {Ref} from "vue";
import {EditPresenter} from "@/utils/presenters/EditPresenter.ts";
import SearchingAndSuggestionUtil from "@/utils/editView/widgets/SearchingAndSuggestionUtil.ts";
import {useLoadingStore} from "@/stores/LoadingStore.ts";
import {FromGridAction} from "@/utils/UIConstants/enums.ts";
import {GridFieldWidgetUtil} from "@/utils/editView/widgets/GridFieldWidgetUtil.ts";
import FieldMetaData = namaTypes.FieldMetaData;
import GenericValue = namaTypes.GenericValue;
import SuggestionProvidedItem = namaTypes.SuggestionProvidedItem;

export default class SuggestionProviderGridFieldWidgetUtil extends GridFieldWidgetUtil<string> {
  constructor(presenter: WidgetsPresenter, columnMetadata: FieldMetaData, fieldValue: Ref<string | null | undefined>, row: number) {
    super(presenter, columnMetadata, fieldValue, row);
  }

  override saveChanges = async () => {
    await this.onUserInputFinished();
    const rowNode = this.params!.api?.getRowNode(this.params!.data.id);
    if (rowNode)
      rowNode.setDataValue(this.params?.column.getColId()!, this.fieldValue.value);
  }

  override onUserInputFinished = async () => {
    this.fieldValue.value = this.inputFieldValueRef.value;
  }

  async suggest(val: string | null | undefined, options: Ref<namaTypes.SuggestionProvidedItem[]>) {
    let contextFields: Record<string, GenericValue> = {};
    this.presenter.fetchDispatcher().addContextFieldsToMap(this.fieldId(), this.createContextFieldsIds(), this.row
      , contextFields, FromGridAction.Yes, [], {});
    let placeExtraFilter;
    if (this.presenter.isEditPresenter())
      placeExtraFilter = (this.presenter as EditPresenter).getPlaceExtraFieldFilterId();
    options.value = await SearchingAndSuggestionUtil.suggest({
      fieldId: this.fieldId(),
      entityType: this.presenter.entityType,
      contextFields,
      currentText: val,
      placeExtraFilter,
      rowIndex: this.row
    });
  }

  onSelect = async (value?: SuggestionProvidedItem) => {
    this.onPartialUserInput(value ? value['optionText'] : null);
    await this.onUserInputFinished();
    const loadingStore = useLoadingStore();
    if (value && value.fieldsToUpdate) {
      loadingStore.startLoading();
      await this.presenter.fetchDispatcher().onGuiActionUpdateList(value.fieldsToUpdate, this.row);
      loadingStore.stopLoading();
    }
  }
}
